import React from "react";
import Slider from "react-slick";
import ReviewCard from "./reviewcard";

function CustomNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "url(https://glocify.com/images/circle-arrow-right.svg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        width: "52px",
        height: "52px",
        cursor: "pointer"
      }}
      onClick={onClick}
    />
  );
}

function CustomPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "url(https://glocify.com/images/circle-arrow-left.svg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        width: "52px",
        height: "52px",
        cursor: "pointer"
      }}
      onClick={onClick}
    />
  );
}

export default function Reviews({ id }) {
  const reviewsData = [
    {
      title: "Music & Live Events App",
      subTitle: "",
      country: "Worldwide",
      platform: "iOS, Android",
      imgUrl: "https://glocify.com/images/music-live-app.png",
      descri:
        "We have built this amazing app where you can listen music of Indie Artists & view Live events across the Globe.",
      list: [
        "Location-Based Services",
        "Push Notifications",
        "AR Video",
      ],
      bgColor: "bg-[linear-gradient(100.92deg,#2E0B59_25.37%,#613FA8_110.63%)]"
    },
    
    {
      title: "Voice & Video Calling App for Astrology",
      subTitle: "",
      country: "Worldwide",
      platform: "iOS, Android",
      imgUrl: "https://glocify.com/images/temple-bliss-app.png",
      descri:
        "We built a Robust Voice & Video calling app for an astrology company",
      list: [
        "Video Calling",
        "Voice Calling",
        "Push Notifications",
        "Subscription"
      ],
      bgColor: "bg-[linear-gradient(102.03deg,#3A0A2D_6.04%,#A44088_107.55%)]"
    },
    {
      title: "Subscription App for a Medical System",
      subTitle: "",
      country: "Worldwide",
      platform: "iOS, Android",
      imgUrl: "https://glocify.com/images/medical-system-app.png",
      descri:
        "We have built a Subscription app which allows customers to customize the product and then subscribe the same product.",
      list: [
        "Push Notifications",
        "Subscription",
        "Product Customization",
        "Email Alert System"
      ],
      bgColor: "bg-[linear-gradient(101.96deg,#093041_-0.79%,#066B72_107.55%)]"
    },
    {
      title: "AI Powered App for Sleep Apnea Detection",
      subTitle: "",
      country: "Worldwide",
      platform: "iOS, Android",
      imgUrl: "https://glocify.com/images/apena-lens-app.png",
      descri:
        "Our expert team developed an AI Powered App which takes patient photos and analysing it using AI to detect Sleep Apnea.",
      list: [
        "Camera Integration",
        "Face Detection",
        "ML Kit",
        "AI Core Integration",
        "Push Notifications"
      ],
      bgColor: "bg-[linear-gradient(102.45deg,#071947_1.61%,#2B52B4_107.53%)]"
    }
  ];

  let reviews = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "22%",
    slidesToShow: 1,
    speed: 500,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "18%"
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "0%",
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        autoplay: true,
        autoplaySpeed: 1500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "0%"
        }
      }
    ]
  };
  return (
    <div
      id={id}
      className="relative block w-full lg:py-[70px] py-[40px] bg-[#F6F6F6] overflow-hidden px-4"
    >
      {/* <div className="blueColorAnimation" /> */}    
      <div className="">        
        <div className="text-center lg:pb-[50px] pb-6">
          <h2
            className="lg:text-[50px] text-[39px] lg:leading-[76px] leading-none font-bold text-black text-center mb-4 tracking-tight"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            Our Portfolio 
          </h2>
          <p
            className="text-base font-normal leading-6 text-black"
            data-aos="fade-up"
            data-aos-duration="800"
          >
            See Our Success in Action—Explore Glocify’s Portfolio of 
            <br className="hidden lg:block" /> Flawless App Creations. 
          </p>
        </div>
        <div>
          <div className="slider-container reviewSlider">
            <Slider {...reviews}>
              {reviewsData.map((review, index) =>
                <ReviewCard
                  key={index}
                  reviewVideo={review.videoUrl}
                  reviewImg={review.imgUrl}
                  reviewTitle={review.title}
                  reviewSubTitle={review.subTitle}
                  reviewDesc={review.descri}
                  reviewBgColor={review.bgColor}
                  reviewList={review.list}
                  reviewCountry={review.country}
                  reviewPlatform={review.platform}
                />
              )}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
